<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="1200px">
      <div class="table">
        <ol>
          <!-- 商品链接 -->
          <li>{{ $t('message.ProductLink') }}</li>
          <!-- 工产 -->
          <li>{{ $t('message.factory') }}</li>
          <!-- 商品图片 -->
          <li>{{ $t('message.productPicture') }}</li>
          <!-- sku -->
          <li>SKU</li>
          <!-- 状态 -->
          <li>{{ $t('message.status') }}</li>
          <!-- 实物图上传 -->
          <li class="flex3">{{ $t('message.physicalImage') }}</li>
        </ol>
        <ul v-for="(item, index) in detail.client_product_link" :key="index">
          <!-- 商品链接 -->
          <li>
            <a :href="item.link.goods_url" target="_blank" rel="noopener noreferrer" class="a-link word-break">{{
              item.link.goods_url }}</a>
          </li>
          <!-- 工厂 -->
          <li>{{ item.item_sku.item.shop_name }}</li>
          <!-- 商品图片 -->
          <li> <el-image style="width: 120px;height: 120px;border-radius: 6px; " :src="item.pic"
              :preview-src-list="[item.pic]">
            </el-image></li>
          <!-- sku -->
          <li>
            <div>
              <p v-for="(detail, detailIndex) in item.item_sku.detail" :key="detailIndex">
                {{ detail.key }} :{{ detail.value }}
              </p>
            </div>
          </li>
          <!-- 状态 -->
          <li></li>
          <!-- 实物图上传 -->
          <li class="flex3">
            <div class="pic-box">
              <!-- 图片列表 -->
              <div class="pic-list">
                <div class="img" v-for="(pic, picIndex) in item.client_product_image_real" :key="picIndex">
                  <img :src="pic.url" alt="">
                  <div class="btn">
                    <i class="el-icon-zoom-in" @click="handlePictureCardPreview(pic)"></i>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="picDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      picDialogVisible: false,
      detail: {
        client_product_link: []
      }
    };
  },
  methods: {
    // 设置数据
    setData(data) {

      this.detail = data
      this.dialogVisible = true
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.picDialogVisible = true;
    },
  }
}
</script>
<style lang='scss' scoped>
.table {
  li {
    justify-content: left;
    padding: 0 15px;
    position: relative;
  }

  .flex3 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  ol {
    height: 56px;
  }

  ul {
    background-color: #fff;
    height: 130px;
    padding: 5px 0;
    border: none;
  }

  .pic-box {
    display: flex;
    width: 100%;

    .pic-list {
      width: 100px;
      flex: 1;
      margin: 0 30px;
      display: flex;
      flex-wrap: wrap;


      .img {
        position: relative;
        width: 60px;
        margin-right: 5px;

        &:hover {
          .btn {
            display: flex;
          }
        }

        .btn {
          position: absolute;
          top: 0;
          left: 0;
          width: 60px;
          height: 60px;
          background-color: rgba(0, 0, 0, 0.2);
          display: none;
          justify-content: center;
          align-items: center;
          border-radius: 5px;

          i {
            color: #fff;
            font-size: 18px;
            cursor: pointer;

            &:nth-last-child(1) {
              margin-left: 10px;
            }
          }
        }

        img {
          width: 60px;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>